

setTimeout(() => {
  const toolbar = document.querySelector(".boost-sd__toolbar-container");

  if (!toolbar) return; // safety check

  // Passive + rAF-throttled to avoid scroll jank on mobile (handler was
  // running a synchronous getBoundingClientRect on every scroll event).
  let ticking = false;
  window.addEventListener("scroll", function () {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      const rect = toolbar.getBoundingClientRect();
      if (rect.top === 0) {
        toolbar.classList.add("active");
      } else {
        toolbar.classList.remove("active");
      }
      ticking = false;
    });
  }, { passive: true });
}, 3000); // 3 seconds delay


// Guarded so it no longer throws null-reference errors on pages (PDPs, etc.)
// that don't contain a .tab-button.active or the #openPopup/#popup/#closePopup
// elements. Those uncaught errors previously broke downstream gallery bindings.
window.addEventListener("load", () => {
  setTimeout(() => {
    const activeTab = document.querySelector(".tab-button.active");
    if (activeTab) activeTab.click();
  }, 1000);

  const openPopupButton = document.getElementById('openPopup');
  const popup = document.getElementById('popup');
  const closePopupButton = document.getElementById('closePopup');
  const body = document.querySelector('body');

  // Only wire up the popup when its required elements exist on this page.
  if (openPopupButton && popup) {
    openPopupButton.addEventListener('click', () => {
      popup.style.display = 'flex';
      if (body) body.classList.add("active_body");
    });

    if (closePopupButton) {
      closePopupButton.addEventListener('click', () => {
        popup.style.display = 'none';
        if (body) body.classList.remove("active_body");
      });
    }

    popup.addEventListener('click', (event) => {
      if (event.target === popup) {
        popup.style.display = 'none';
        if (body) body.classList.remove("active_body");
      }
    });
  }
});







 